import DefaultLayout from "../components/layout/DefaultLayout";
function RequirementsPage() {
  const body = () => {
    return (
      <div>
        <section class="slice sct-color-1" id="scrollToSection">
          <div class="container">
            <div class="row cols-xs-space cols-md-space cols-sm-space">
              <div class="col-lg-12">
                <div class="icon-block icon-block--style-2-v1 text-center">
                  <div class="block-icon circle bg-base-1">
                    <i class="ion-ios-clock"></i>
                  </div>
                  <h2 class="heading heading-5 strong-500">Requisitos</h2>
                  <p class="px-4">
                    Fotocopia de cédula del solicitante y los arrendatarios
                    solidarios.
                  </p>
                  <p class="px-4">
                    2 codeudores que cuenten con trabajo estable ( certificado
                    laboral )
                  </p>
                  <p class="px-4">
                    1 codeudor con propiedad raiz ( impuesto predial y
                    certificado de libertad actualizado sin afectacion a
                    vivienda ,ni patrimonio familiar).
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  };
  return (
    <div>
      <div>
        <DefaultLayout body={body()} />
      </div>
    </div>
  );
}

export default RequirementsPage;
